// extracted by mini-css-extract-plugin
module.exports = {"container":"cardComparisonOverlay_container__YJRbV","cards":"cardComparisonOverlay_cards__OE6l9"};